<template>
  <v-card class="pa-3">
        <v-card-title>
            Agregar Plan Alimenticio
        </v-card-title>
        <v-row class="ma-0 px-4">
            <v-col cols="12" class="pb-0">
                <v-text-field outlined v-model="meal_plan.name" item-text="name" label="Titulo"></v-text-field>
            </v-col>
            <!--v-col cols="6" class="pb-0 pt-0">
                <v-autocomplete outlined v-model="meal_plan.user_id" :items="usersList" :loading="isLoadingUsers" :search-input.sync="searchUsers" hide-no-data item-value="id" item-text="name" label="Paciente" placeholder="Escribe para buscar" attach></v-autocomplete>
            </v-col-->
            <v-col cols="12" class="pb-0 pt-0">
                <v-file-input
                    ref="pdf"
                    accept="pdf/*"
                    v-model="pdf"
                    label="PDF"
                    :loading="uploading"
                    outlined 
                ></v-file-input>
            </v-col>
            <v-col cols="12"  class="pt-0 mt-0">
                <v-textarea v-model="meal_plan.note" outlined label="Notas"></v-textarea>
            </v-col>
        </v-row>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
                Cancelar
            </v-btn>
            <v-btn color="blue darken-1" :loading="gris" :disabled="gris || !valid" text @click="save">
                Guardar
            </v-btn>
        </v-card-actions>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios"
export default {
    data: () => ({
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        uploading:false,
        gris:false,
        meal_plan:{
            user_id:'',
            file_path:'',
            note:'',
            name:''
        },
        entries:{
            users: []
        },
        isLoadingUsers: false,
        searchUsers: null,
        pdf:''
    }),
    watch: {
        searchUsers(val){
            if (this.isLoadingUsers) return
            this.isLoadingUsers = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/users?filter[name]='+val)
            .then(res => {
                this.entries.users = res.data.data
            }).finally(() => (this.isLoadingUsers = false))
        },
        pdf:{
            handler(){    
                let formData = new FormData();
                formData.append('file', this.pdf);
                this.uploading = true
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/meal_plan/upload"
                    ,formData
                    ,{headers: {"Content-Type": "multipart/form-data"}}
                ).then(response=>{
                    this.uploading = false
                    this.fileName = response.data.file
                    this.meal_plan.file_path = process.env.VUE_APP_BACKEND_ROUTE + 'files/' + response.data.file
                })
            },deep:true,
        }
    },
    computed: {
        valid(){
            if(this.meal_plan.file_path!=''&&this.meal_plan.file_path!=undefined&&this.meal_plan.file_path!=null){
                return true
            }else{
                return false
            }
        },
        usersList(){
            return this.entries.users.map(id => {
                return{
                    id:id.id,
                    name:id.name,
                }
            })
        }  
    },
    methods: {
        close () {
            this.pdf = ''
            this.fileName = ''
            this.meal_plan = Object.assign({}, this.defaultItem)
            this.gris = false
            this.$nextTick(() => {
                this.$emit("closeCreateDialog", false);
            })
        },
        save(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/users?filter[id]='+this.$route.params.id)
            .then(res => {
                this.meal_plan.user_id = this.$route.params.id
                this.gris = true
                var whitasapp = res.data.data[0].phone
                this.$nextTick(() => {
                    axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/meal_plans",Object.assign(this.meal_plan)).then(response=>{
                        window.open('https://web.whatsapp.com/send/?phone=' + whitasapp + '&text=' + encodeURIComponent('Tu plan alimenticio está listo 👍 revísalo en https://app.bignow.mx/?plan=' + this.fileName))
                        this.close()
                    }).catch(error => {
                        this.snackbar = {
                            message: error.response.data.message,
                            color: 'error',
                            show: true
                        }
                        this.gris = false
                    })
                })
            })
        },
    },
}
</script>

<style>

</style>